<template>
    <a-modal
    :title="title"
    :width="1000"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
      <a-spin :spinning="confirmLoading">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane :key="1" :tab="$t('数据详情')">
            <detail-list :col="2">
              <detail-list-item :term="$t('告警等级')">
                <label :class="model.warnClevel === 1?'warn-danger':model.warnClevel === 2?'warn-primary':model.warnClevel === 3?'warn-secondary':''">
                {{'maintenance_warn_clevel'|filterDictTextByCache(model.warnClevel)}}
                </label>
              </detail-list-item>
              <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
              <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
              <detail-list-item :term="$t('软件版本号')">{{model.meterSoftVersion}}</detail-list-item>
              <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr?model.userMeterAddr: '--'}}</detail-list-item>
              <detail-list-item :term="$t('信号rsrp值')">{{model.signalRsrp}}</detail-list-item>
              <detail-list-item :term="$t('信号snr值')">{{model.signalSnr}}</detail-list-item>
              <detail-list-item :term="$t('信号csq值')">{{model.signalCsq}}</detail-list-item>
              <detail-list-item :term="$t('信号rsrq值')">{{model.signalRsrq}}</detail-list-item>
              <detail-list-item :term="$t('信号覆盖等级')">{{model.signalClevel}}</detail-list-item>
              <detail-list-item :term="$t('温度')">{{model.meterTemp?model.meterTemp: '--'}}</detail-list-item>
              <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
              <detail-list-item :term="$t('告警规则')">{{model.warnName}}</detail-list-item>
              <detail-list-item :term="$t('告警时间')">{{model.updateTime}}</detail-list-item>
              <detail-list-item :term="$t('告警描述')">{{model.meterWarnDetail}}</detail-list-item>
              <detail-list-item :term="$t('处理状态')">{{model.meterDealStatus==2?$t('已处理'):model.meterDealStatus==1?$t('处理中'): $t('未处理')}}</detail-list-item>
              <detail-list-item :term="$t('处理描述')">{{model.meterDealStatus==2?model.meterWarnDealDescription2:model.meterDealStatus==1?model.meterWarnDealDescription1: model.meterWarnDealDescription0}}</detail-list-item>
            </detail-list>
          </a-tab-pane>
          <a-tab-pane :key="2" :tab="$t('历史电压告警记录')">
            <div class="form-contain">
              <div class="table-page-search-wrapper">
                <a-form layout="inline" @keyup.enter.native="searchQuery">
                  <a-row :gutter="24">
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('处理状态')">
                        <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                          <a-select-option value="0">
                            {{ $t('未处理') }}
                          </a-select-option>
                          <a-select-option value="1">
                            {{ $t('处理中') }}
                          </a-select-option>
                          <a-select-option value="2">
                            {{ $t('已处理') }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="10" :lg="6" :md="7" :sm="24">
                      <a-form-item :label="$t('告警日期')">
                        <a-range-picker
                          v-model="date"
                          format="YYYY-MM-DD"
                          :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                          @change="onDateRangeChange"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                      <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                      </span>
                    </a-col>
                  </a-row>
                </a-form>
              </div>
              <div>
                <detail-list :col="3">
                  <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                  <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
                  <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                  <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr?model.userMeterAddr: '--'}}</detail-list-item>
                  <detail-list-item :term="$t('部门编号')">{{model.sysOrgCode}}</detail-list-item>
                  <detail-list-item :term="$t('部门名称')">{{model.departName}}</detail-list-item>
                </detail-list>
              </div>
              <div>
                <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
                  <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
                  <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
                  <a-button v-if="selectedRowKeys.length > 0" style="float: right;margin-left: 8px" type="primary" @click="batchDeal" size="small"> {{ $t('批量处理') }}</a-button>
                </div>
                <a-table 
                  :columns="columns"
                  :dataSource="dataSource"
                  :scroll="{x:true}"
                  rowKey='id'
                  size="middle"
                  :pagination="ipagination"
                  @change="handleTableChange"
                  :loading="loading"
                  class="j-table-force-nowrap"
                  :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onTableSelect,onSelectAll:onSelectAll,getCheckboxProps:getCheckboxProps}"
                >
                  <span slot="warnClevel" slot-scope="text, record">
                    <label :class="record.warnClevel === 1?'warn-danger':record.warnClevel === 2?'warn-primary':record.warnClevel === 3?'warn-secondary':'warn-third'">
                      {{'maintenance_warn_clevel'|filterDictTextByCache(text)}}
                      
                    </label>
                  </span>
                  <span slot="meterDealStatus" slot-scope="text, record">
                    <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
                    <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
                    <label v-else class="wait-status">{{ $t('未处理') }}</label>
                  </span>
                  <span slot="action" slot-scope="text, record" class="action">
                    <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                    <a :disabled="record.meterDealStatus == 2" @click="handleEdit(record)">{{ $t('处理') }}</a>
                  </span>
                </a-table>
                </div>
            </div>
          </a-tab-pane>
          <a-tab-pane :key="3" :tab="$t('历史图表')">
            <div>
              <a-form layout="inline" @keyup.enter.native="batteryChartSearchQuery" >
                <a-row :gutter="24">
                  <a-col :xl="16" :lg="12" :md="10" :sm="24">
                    <a-form-item :label="$t('查询起止时间')">
                        <a-range-picker
                          v-model="batteryChartDate"
                          :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                          format="YYYY-MM-DD"
                        />
                    </a-form-item>
                  </a-col>  
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="batteryChartSearchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="batteryChartSearchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
              <div class="m-panel">
                  <div class="m-panel-bar">
                      <div class="m-panel-bar-title">
                      </div>
                  </div>
                  <div class="m-panel-body">
                    <a-empty v-if="voltageRecord.length==0" />
                    <Echart v-else ref="option" :options="option" style="height: 100%"></Echart>
                  </div>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
      <meter-warn-history-record-deal-modal ref="modalForm" @ok="modalFormOk"></meter-warn-history-record-deal-modal>
      <meter-warn-history-record-detail-modal ref="detailModalForm" @ok="modalFormOk"></meter-warn-history-record-detail-modal>
    </a-modal>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import echarts from 'echarts/lib/echarts';
  import moment from 'moment'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import { isEmptyObject,isUndefined } from '@/utils/validate'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  const colorList = ['#FECA20','#50E3C2', '#0091FF','#4634FA','#B620E0','#F7B500','#FA6400','#E02020'];
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import meterWarnHistoryRecordDealModal from './meterWarnHistoryRecordDealModal'
  import meterWarnHistoryRecordDetailModal from './meterWarnHistoryRecordDetailModal'
  export default {
    name: 'MeterUserAccountForm',
    mixins:[JeecgListMixin],
    filters: {
      filterDictTextByCache
    },
    components: {
      JFormContainer,
      DetailList,
      DetailListItem,
      meterWarnHistoryRecordDealModal,
      meterWarnHistoryRecordDetailModal
    },
    data () {
      return {
        model: {},
        netTypeObj,
        meterTypeObj,
        title: '',
        confirmLoading: false,
        disableSubmit:false,
        visible: false,
        validatorRules: {
        },
        url: {
          list: "/jeecg-charge/meter/meterMaintenanceWarnRecord/warnPageList",
          getMeterVoltageByMeterId:"/jeecg-charge/meter/meterUpDataAnalysis/getMeterVoltageByMeterId"
        },
        date:[],
        dateType: 2,
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {meterWarnType: 1},
        batteryChartDate: [],
        intervalId: null,
        voltageRecord: [],
        option: {},
        /* 排序参数 */
        isorter:{
          column: 'updateTime',
          order: 'desc',
        },
      }
    },
    computed: {
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title:'RSRP',
            align:"center",
            dataIndex: 'signalRsrp'
          },
          {
            title:'SNR',
            align:"center",
            dataIndex: 'signalSnr'
          },
          {
            title:'CSQ',
            align:"center",
            dataIndex: 'signalCsq'
          },
          {
            title: this.$t('告警等级'),
            align:"center",
            dataIndex: 'warnClevel',
            scopedSlots: { customRender: 'warnClevel' }
          },
          {
            title: this.$t('告警描述'),
            align:"center",
            dataIndex: 'meterWarnDetail'
          },
          {
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('运营商'),
            align:"center",
            dataIndex: 'meterIotType',
            customRender: (t,r,index) => {
              let data = netTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            }
          },
          {
            title: this.$t('告警时间'),
            align:"center",
            dataIndex: 'updateTime',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    created () {
    },
    methods: {
      moment,
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.uniqueParam.meterId = this.model.meterId;
        this.changeTab(1);
        this.disableSubmit = true;
        this.visible = true;
      },
      shut() {
        this.activeKey = 1;
        this.queryParam = {};
        this.list = [];
        this.date = [];
        this.onClearSelected();
      },
      close () {
        this.$emit('close');
        this.shut();
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        console.log(this.activeKey)
        if(this.activeKey == 2) {
          this.loadData(1)
        }else if(this.activeKey == 3) {
          this.querygetMeterVoltageByMeterId(1)
        }
      },
      clearIntervalId() {
        if(this.intervalId !== null){
            clearInterval(this.intervalId)
            this.intervalId = null;
        }
      },
      batteryChartSearchQuery() {
        this.option ={};
        this.clearIntervalId();
        this.querygetMeterVoltageByMeterId()
      },
      batteryChartSearchReset(){
        this.batteryChartDate = []
        this.option ={};
        this.clearIntervalId();
        this.querygetMeterVoltageByMeterId()
      },
      handleDetail:function(record){
        this.$refs.detailModalForm.edit(record);
        this.$refs.detailModalForm.title=this.$t("详情");
        this.$refs.detailModalForm.disableSubmit = true;
      },
      handleEdit: function (record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = this.$t("处理");
        this.$refs.modalForm.disableSubmit = false;
      },
      batchDeal() {
        // 批量处理告警
        if(this.selectionRows.length<1){
          this.$message.error(this.$t("请先选择需要批量处理的记录"))
          return
        }else{
          let idList = []
          let meterDealStatus = ''
          for(let i = 0;i<this.selectionRows.length;i++) {
            if(i === 0) {
              meterDealStatus = this.selectionRows[0].meterDealStatus
            }else{
              if(meterDealStatus !== this.selectionRows[i].meterDealStatus) {
                this.$message.error(this.$t("选择批量处理的处理进度不一致不能操作，请重新选择同一处理进度的表具"))
                return
              }
            }
            idList.push(this.selectionRows[i].id)
          }
          let record = {}
          record.idList = idList.join(',')
          record.meterDealStatus = meterDealStatus
          record.meterWarnType = this.uniqueParam.meterWarnType
          this.handleEdit(record)
        }
      },
      getCheckboxProps(record) {
        let props = {
          disabled: record.meterDealStatus == 2,
          meterDealStatus: record.meterDealStatus
        }
        return {props: {...props}};
      },
      querygetMeterVoltageByMeterId() {
        let params = {}
        params.meterId = this.model.meterId
        if (this.batteryChartDate.length>0) {
          params.beginDate = moment(this.batteryChartDate[0]).format('YYYY-MM-DD');
          params.endDate = moment(this.batteryChartDate[1]).format('YYYY-MM-DD');
        } else {
          params.beginDate = moment().subtract(1, "months").format("YYYY-MM-DD");
          params.endDate = moment().format('YYYY-MM-DD');
          this.batteryChartDate=[moment().subtract(1, "months"),moment()]
        }
        getAction(this.url.getMeterVoltageByMeterId, params).then((res) => {
          if(res.success){
            if (res.code==0) {
              this.voltageRecord = res.result;
              this.setOption();
            } 
          }
        }) 
      },
      setOption() {
          let xData = []
          for(let i = 0;i<this.voltageRecord.dateStrList.length;i++) {
            let date = moment(this.voltageRecord.dateStrList[i]).format('MM-DD HH:mm')
          xData.push(date.substring(0,5)+'\n'+date.substring(5,11))   
          console.log(xData);
          }
          let voltage = []
          for(let i = 0;i< this.voltageRecord.valtageRecordsList.length;i++) {
            voltage.push((this.voltageRecord.valtageRecordsList[i]/1000)) 
          }
          let snrRecords = this.voltageRecord.snrRecordsList;
          let csqRecords = this.voltageRecord.csqRecordsList;
          let rsrpRecords = this.voltageRecord.rsrpRecordsList;
          let tempRecords = this.voltageRecord.tempRecordsList;
          this.option = {
            backgroundColor: '#fff',
            title: {
              show: false,
                text: this.$t('电池电压折线统计图'),
                textStyle: {
                    fontSize: 12,
                    fontWeight: 400
                },
                left: 'center',
                top: '5%'
            },
            legend: {
                icon: 'circle',
                itemWidth: 10,
                itemGap: 20,
                textStyle: {
                    color: '#556677'
                },
                data: ['SNR','CSQ','RSRP',this.$t('温度'),this.$t('电池电压')]
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'cross',
                    label: {
                        show: true,

                    },
                    lineStyle: {
                        width: 0
                    }
                },
                backgroundColor: '#fff',
                textStyle: {
                    color: '#5c6c7c'
                },
                padding: [10, 10],
                extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
            },
            grid: {
                top: '15%',
                left: 150,
            },
            xAxis: [{
                type: 'category',
                data: xData,
                axisLine: {
                  show: true,
                    lineStyle: {
                        color: 'rgba(107,107,107,0.37)', //x轴颜色
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    textStyle: {
                        color: '#999' //坐标轴字颜色
                    },
                    margin: 15
                },
                splitLine: {
                  show: false
                },
                axisPointer: {
                    label: {
                        padding: [11, 5, 7],
                        /*
                        backgroundColor: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: '#fff' // 0% 处的颜色
                            }, {
                                offset: 0.9,
                                color: '#fff' // 0% 处的颜色
                            }, {
                                offset: 0.9,
                                color: '#33c0cd' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#33c0cd' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }
                        */
                    }
                },
                boundaryGap: false
            }],
            yAxis: [{
                type: 'value',
                name: this.$t('电池电压(V)'),
                position: 'right',
                scale:true, // y轴不从0开始
                axisTick: {
                    show: true,
                    inside: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: colorList[0]
                    }
                },
                axisLabel: {
                    textStyle: {
                        color: colorList[0]
                    }
                },
                splitLine: {
                    show: false
                }
            },{
                type: 'value',
                name: 'SNR',
                position: 'left',
                scale:true, // y轴不从0开始
                axisTick: {
                    show: true,
                    inside: true,
                },
                offset: 35, // 偏移
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: colorList[1],
                    }
                },
                axisLabel: {
                    textStyle: {
                        color: colorList[1],
                    }
                },
                splitLine: {
                    show: false,
                    
                }
            },
            {
                type: 'value',
                name: 'CSQ',
                position: 'left',
                scale:true, // y轴不从0开始
                axisTick: {
                    show: true,
                    inside: true,
                },
                offset: 70, // 偏移
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: colorList[2],
                    }
                },
                axisLabel: {
                    textStyle: {
                        color: colorList[2],
                    }
                },
                splitLine: {
                    show: false
                }
            },{
                type: 'value',
                name: 'RSRP',
                position: 'left',
                scale:true, // y轴不从0开始
                axisTick: {
                    show: true,
                    inside: true,
                },
                offset: 105, // 偏移
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: colorList[3],
                    }
                },
                axisLabel: {
                    textStyle: {
                        color: colorList[3],
                    }
                },
                splitLine: {
                    show: false
                }
            },
            {
                type: 'value',
                name: this.$t('温度(℃)'),
                position: 'left',
                scale:true, // y轴不从0开始
                axisTick: {
                    show: true,
                    inside: true,
                },
                offset: 0, // 偏移
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: colorList[4]
                    }
                },
                axisLabel: {
                    textStyle: {
                        color: colorList[4]
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#ccc',
                        type: 'dotted'
                    }
                }
            }
            ],
            series: [{
                name: this.$t('电池电压'),
                type: 'line',
                data: voltage,
                symbolSize: 1,
                symbol: 'circle',
                smooth: true,
                yAxisIndex: 0,
                showSymbol: false,
                lineStyle: {
                    width: 2,
                    color: colorList[0]
                },
                itemStyle: {
                    normal: {
                        color: colorList[0],
                        borderColor: colorList[0]
                    }
                }
            }, {
                name: 'SNR',
                type: 'line',
                data: snrRecords,
                symbolSize: 1,
                symbol: 'circle',
                smooth: true,
                yAxisIndex: 1,
                showSymbol: false,
                lineStyle: {
                    width: 2,
                    color: colorList[1]
                },
                itemStyle: {
                    normal: {
                        color: colorList[1],
                        borderColor: colorList[1]
                    }
                }
            }, {
                name: 'CSQ',
                type: 'line',
                data: csqRecords,
                symbolSize: 1,
                symbol: 'circle',
                smooth: true,
                yAxisIndex: 2,
                showSymbol: false,
                lineStyle: {
                    width: 2,
                    color: colorList[2],
                },
                itemStyle: {
                    normal: {
                        color: colorList[2],
                        borderColor: colorList[2]
                    }
                }
            }, {
                name: 'RSRP',
                type: 'line',
                data: rsrpRecords,
                symbolSize: 1,
                symbol: 'circle',
                smooth: true,
                yAxisIndex: 3,
                showSymbol: false,
                lineStyle: {
                    width: 2,
                    color: colorList[3]
                },
                itemStyle: {
                    normal: {
                        color: colorList[3],
                        borderColor: colorList[3]
                    }
                }
            }, {
                name: this.$t('温度'),
                type: 'line',
                data: tempRecords,
                symbolSize: 1,
                symbol: 'circle',
                smooth: true,
                yAxisIndex: 4,
                showSymbol: false,
                lineStyle: {
                    width: 2,
                    color: colorList[4]
                },
                itemStyle: {
                    normal: {
                        color: colorList[4],
                        borderColor: colorList[4]
                    }
                }
            }, 
            ]
          };
          /*
          let i = 0
          let that = this
          this.intervalId = setInterval(function(){
            // console.log(i)
            i = i === xData.length ? 0 : i+1
            that.$refs.option.dispatchAction({
                type: 'showTip',
                seriesIndex:0,  // 显示第几个series
                dataIndex: i // 显示第几个数据
            });
          }, 1000)
          */
      }
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
.m-panel-body{
  margin-top: 20px;
  height: 500px;
}
</style>